import type Product from '@modules/product/type/product';
import type { MetaDescriptor } from 'react-router';
import type { ProductCategory } from '@modules/product/component/product-details/ProductDetails';

const getCategoryPath = (category: ProductCategory): string => {
    const paths: string[] = [];

    category.Parents?.forEach((parent) => {
        if (parent?.PrettyTitle && parent?.Link) {
            paths.push(parent.PrettyTitle);
        }
    });

    if (category.PrettyTitle) {
        paths.push(category.PrettyTitle);
    }
    return paths.join(' > ');
};

const createProductOGTags = (
    product?: Product,
    currency?: string,
): MetaDescriptor[] => {
    if (!product) {
        return [];
    }
    const category = product.ProductCategories?.[0] ?? null;

    const tags = [
        {
            property: 'product:custom_label_0',
            content: product.CanPurchase ? '1' : '0',
        },
        {
            property: 'product:custom_label_1',
            content: category ? getCategoryPath(category) : '',
        },
        {
            property: 'product:custom_label_2',
            content: product.ExcludeAdvertising ? '1' : '0',
        },
    ];

    const price = product.PricingDisplay?.Text;

    if (currency && price) {
        const retailPrice = product.PricingDisplay?.ReplacedText ?? price;
        tags.push({
            property: 'product:price:amount',
            content: retailPrice,
        });
        tags.push({ property: 'product:price:currency', content: currency });

        if (retailPrice && price < retailPrice) {
            tags.push({
                property: 'product:sale_price:amount',
                content: price,
            });
            tags.push({
                property: 'product:sale_price:currency',
                content: currency,
            });
        }
    }

    return tags;
};

export default createProductOGTags;
